'use strict';
import $ from 'jquery';

export default class Forms {
	constructor() {

		if($('form').length > 0){
			var $form = window.location.hash.substr(1);
			
			if ($form == 'login'){
				$('.form').hide();
				$('.form-login').show();
			} else if ($form == 'password'){
				$('.form').hide();
				$('.form-password').show();
			} else if ($form == 'reset'){
				$('.form').hide();
				$('.form-reset').show();
			} else {
				$('.form').hide();
				$('.form-register').show();
			}
			
			$('.switch2login').on('click',function(){
				$('.form').hide();
				$('.form-login').show();
			});
			
			$('.switch2signUp').on('click',function(){
				$('.form').hide();
				$('.form-register').show();
			});
			
			$('.forgot').on('click',function(){
				$('.form').hide();
				$('.form-password').show();
			});
			
			$('.accountType').on('change',function(){
				var $accountType = $(this).val()
				
				if($accountType == '0'){
					$('.swimmer').show();
					$(".parent-email").prop('required',true);
				} else { 
					$('.swimmer').hide();
					$(".parent-email").prop('required',false);
				}	
			});
			
			$('.above18').on('change',function(){
				if($(this).is(":checked")) {
					$('.not-18').hide();
					$(".parent-email").prop('required',false);
				} else {
					$('.not-18').show();
					$(".parent-email").prop('required',true);
				}
			})
			
			$(".form-login").submit(function(event) {
				 $.ajax({
					success: function() {
						window.location.href = "/video-list.html"
					},
					error: function() {
						$('.form-error').show();
					}
				});
				return false;
			});
			
			$(".form-register").submit(function(event) {
				 $.ajax({
					success: function() {
						$('.form').hide();
						$('.form-login').show();
						$('.form-login').find('h2').text('Please sign in with your emailed login details').css('text-transform','none');
					},
					error: function() {
						//$('.form-error').show();
					}
				});
				return false;
			});
			
			$(".form-password").submit(function(event) {
				 $.ajax({
					success: function() {
						$('.form-password .form-msg').show();
					},
					error: function() {
						$('.form-password .form-error').show();
					}
				});
				return false;
			});
			
			$(".form-contact").submit(function(event) {
				 $.ajax({
					success: function() {
						$('.form-contact').hide();
						$('.form-msg').show();
					},
					error: function() {
						$('.form-error').show();
					}
				});
				return false;
			});
		}
	}
}
